import { auth } from "./firebase";

const CREATE_CONSULTATION_SESSION_URL =
  process.env.REACT_APP_CREATE_CONSULTATION_SESSION_URL ||
  "https://us-central1-petaar-3dcab.cloudfunctions.net/createConsultationSession";

export function isVetConsultationBooking(booking = {}) {
  return (
    String(booking?.bookingType || "").trim().toLowerCase() === "vet_consultation" ||
    String(booking?.category || "").trim().toLowerCase() === "veterinary & health care"
  );
}

export function normalizeConsultationMode(modeValue = "") {
  const mode = String(modeValue || "").trim().toLowerCase();
  if (["audio", "video", "chat"].includes(mode)) return mode;
  return "chat";
}

export function getConsultationJoinLabel(modeValue = "") {
  const mode = normalizeConsultationMode(modeValue);
  if (mode === "video") return "Video Call";
  if (mode === "audio") return "Audio Call";
  return "Chat";
}

export function canJoinConsultationCall(booking = {}) {
  if (!isVetConsultationBooking(booking)) return false;
  const status = String(booking?.status || "").trim().toLowerCase();
  if (["cancelled", "completed"].includes(status)) return false;
  const consultationStatus = String(booking?.consultationStatus || "").trim().toLowerCase();
  const assignmentStatus = String(booking?.assignmentStatus || "").trim().toLowerCase();
  const hasAssignedVet =
    assignmentStatus === "assigned" ||
    Boolean(booking?.assignedProviderId) ||
    Boolean(booking?.providerId) ||
    Boolean(booking?.providerEmail) ||
    Boolean(booking?.assignedVetProfile) ||
    ["vet_assigned", "vet_accepted", "consultation_live", "prescription_sent", "consultation_completed"].includes(consultationStatus);
  if (!hasAssignedVet) return false;
  const mode = normalizeConsultationMode(booking?.consultationMode || "");
  return mode === "audio" || mode === "video";
}

async function fetchSecureConsultationJoinUrl(booking = {}) {
  const bookingId = String(booking?.id || "").trim();
  if (!bookingId) return "";
  const token = await auth.currentUser?.getIdToken?.();
  if (!token) return "";
  const response = await fetch(CREATE_CONSULTATION_SESSION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ bookingId }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data?.success) {
    throw new Error(data?.error || `Unable to create consultation session (${response.status})`);
  }
  return String(data.joinUrl || "").trim();
}

export async function getConsultationJoinUrl(booking = {}) {
  return fetchSecureConsultationJoinUrl(booking);
}

export async function openConsultationCallWindow(booking = {}) {
  const url = await getConsultationJoinUrl(booking);
  const popup = window.open(url, "_blank", "noopener,noreferrer");
  if (popup) return;
  alert("Popup blocked. Please allow popups to join the consultation call.");
}
